// extracted by mini-css-extract-plugin
export default {"topview":"Clock_topview__oSWGp","centered":"Clock_centered__hhqnR","clock":"Clock_clock__xpAQz"};